"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userUpdateValidation = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email],
  first_name: _validation.required,
  last_name: _validation.required,
  phone: _validation.required,
  password: [(0, _validation.minLength)(8)],
  password2: [(0, _validation.matchPasswords)("password")]
});
exports.default = (0, _lruMemoize2.default)(10)(userUpdateValidation);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyProfile/userUpdateValidator.js
 ** module id = 1222
 ** module chunks = 0
 **/